import axios, { AxiosResponse } from 'axios';
import { retryPromise } from '../helpers/retryPromise';
import bearerAxios from "../helpers/bearerAxios";
import { GetIdealMultipliersResponse } from '../domain/models/http/responses/GetIdealMultipliersResponse';
import { GetAccessMultipliersRequest } from "../domain/models/http/requests/GetAccessMultipliersRequest";
import { GetAccessMultipliersResponse } from "../domain/models/http/responses/GetAccessMultipliersResponse";

export async function getAccessMultipliers(payload: GetAccessMultipliersRequest): Promise<AxiosResponse<GetAccessMultipliersResponse>> {
    return await bearerAxios.post(
        import.meta.env.VITE_BASE_URL + import.meta.env.VITE_PVWATTS_MULTIPLIER_COMMON_URL!,
        payload);
}

export async function getIdealMultiplier(opportunityId: string, latitude: number, longitude: number, tilt: number) {
    const payload: GetIdealMultipliersRequest = {
        opportunityId: opportunityId,
        latitude: latitude,
        longitude: longitude,
        tilt: tilt
    }
    const res = await retryPromise<GetIdealMultipliersResponse>(async () => {
        const res: AxiosResponse<GetIdealMultipliersResponse> = await bearerAxios.post(
            import.meta.env.VITE_BASE_URL + import.meta.env.VITE_PVWATTS_IDEAL_API_URL!,
            payload);

        return res.data;
    }, {
        retries: 20,
        factor: 2,
        minTimeout: 200,
        maxTimeout: 60 * 1000,
        randomize: true
    });

    return res;
}
export async function saveMonthlyProductionEstimate(payload: any) {
    const response = await bearerAxios.post(
        import.meta.env.VITE_BASE_URL + import.meta.env.VITE_SAVE_MONTHLY_PRODUCTION_VALUES!,
        payload,
        {
            headers: {
                "Content-Type": "application/json",
            },
        }
    );

    return response.data;
}